import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Box } from '@mui/material';

import Layout from 'components/Layout';
import Header from 'components/Hostels/Header';
import { ExperiencesList } from '@utriper/core-ui';
import { useExperiences } from 'core/contexts/experience';
import { useHostel } from 'core/contexts/hostel';
import { useFilters } from 'core/contexts/filter';
import { useSorts } from 'core/contexts/sort';
import { useTranslation } from 'core/contexts/localization';

import { ExperienceService } from 'core/api/services/experiences';

const Template = () => {
    const { qrExperiences, getHostelExperiences } = useExperiences();
    const { priceOrder } = useSorts();
    const { tourOperatorsId, moduses } = useFilters();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const code = params.get('code');
    const history = useHistory();
    const { setCode, sectionId, setSectionId, data } = useHostel();

    useEffect(() => {
        if (code != null) {
            setCode(code);
        } else {
            history.replace('/');
        }
    }, [code]);

    useEffect(() => {
        if (code != null) {
            getHostelExperiences(code, priceOrder, moduses, tourOperatorsId, sectionId);
        }
    }, [priceOrder, moduses, code, tourOperatorsId, sectionId]);

    return (
        <Layout>
            <Header />
            <Box
                sx={{
                    backgroundImage: 'url("/static/media/landingbg.f640a989.jpg")',
                    mt: 2,
                    display: 'flex',
                    justifyContent: 'center',
                    margin: { xs: '2rem 1rem', xl: '2rem auto' },
                    padding: '0 1rem',
                    maxWidth: { xs: 'auto', lg: '1440px' },
                }}>
                <ExperiencesList code={code} contractExperiences={qrExperiences} getMediaById={ExperienceService.getMediaById} />
            </Box>
        </Layout>
    );
};
export default Template;
